// src/components/ui/Tabs.js
import React from 'react';

export function Tabs({ tabs, activeTab, onChange, className = '' }) {
  return (
    <div className={`flex border-b border-gray-200 mb-6 ${className}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`
            py-4 px-6 font-medium text-sm transition-all border-b-2 
            ${activeTab === tab.id 
              ? 'border-primary text-primary' 
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
          `}
        >
          <div className="flex items-center">
            {tab.icon && <tab.icon className="w-4 h-4 mr-2" />}
            {tab.label}
          </div>
        </button>
      ))}
    </div>
  );
}
